import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import LoginScreen from "./components/LoginScreen";
import MainScreen from "./components/MainScreen";
import CategoryScreen from "./components/CategoryScreen";
import { AuthProvider, useAuthContext } from "./contexts/AuthContext";
import { FinanceProvider } from "./contexts/FinanceContext";
import InstallPwaPrompt from "./components/InstallPwaPrompt";

const ProtectedLayout: React.FC = () => {
  const { isAuthenticated } = useAuthContext();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return (
    <FinanceProvider>
      <Outlet />
    </FinanceProvider>
  );
};

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <InstallPwaPrompt />
        <div className="min-h-screen bg-zinc-50">
          <Routes>
            <Route path="/login" element={<LoginScreen />} />
            <Route element={<ProtectedLayout />}>
              <Route path="/main" element={<MainScreen />} />
              <Route path="/categories" element={<CategoryScreen />} />
            </Route>
            <Route path="/" element={<Navigate to="/login" replace />} />
          </Routes>
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
